import { ThunkAction } from 'redux-thunk';
import { NeoState } from '~/store/Reducers.interface';
import { INeoAction } from '~/store/Actions.interface';
import { dispatchSuccess } from '~/Helpers/Request.helper';
import { STATIC_ACTIONS } from '~/Constants/Actions.constants';

export const setWarning = (
  payload: boolean,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.SET_GLOBAL_WARNING, payload, {});

export const clearProductTour = (): ThunkAction<any, NeoState, unknown, INeoAction> => async (
  dispatch,
) => dispatchSuccess(dispatch, STATIC_ACTIONS.CLEAR_GLOBAL_WARNING, {}, {});
